import React from 'react';
import { QuestionFull } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { Box, BoxProps, SvgIcon, svgIconClasses } from '@mui/material';

const iconStyles = { width: 18, height: 18 } as const;
const tooltipContentSx: BoxProps['sx'] = {
  ...flex.itemsCenter,
  fontSize: 12,
  gap: 1,
  maxWidth: 428,
  [`& .${svgIconClasses.root}`]: {
    ...flex.row,
    alignSelf: 'flex-start',
    fontSize: 18,
  },
  [`& .${svgIconClasses.root} svg`]: iconStyles,
};

export const StyledTooltipTitleWithIcon = ({ children, sx, ...props }: BoxProps) => (
  <Box sx={{ ...tooltipContentSx, ...sx }} {...props}>
    <SvgIcon component="span">
      <QuestionFull viewBox="0 0 20 20" />
    </SvgIcon>
    <div>{children}</div>
  </Box>
);
StyledTooltipTitleWithIcon.iconStyles = iconStyles;
